<template>
  <span :class="nontag ? '' : 'jps-tag jps-tag-ricon'" v-if="fieldValue">
    <slot :field="fieldValue">
      <template v-if="fieldValue.database !== 'default'"
        >{{ ls(fieldValue.databaseName) }}：</template
      >
      {{ ls(fieldValue.label) }}
      <UiButtonIcon
        v-if="deletable"
        class="jps-icon-button generated-10"
        icon="mdi/close-circle"
        :arialabel="ls(dapLangGlobal.delete)"
        @click="emits('delete')"
      />
    </slot>
  </span>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { ls } = useI18n()
const dataStore = useDataStore()

interface Props {
  nontag?: boolean
  field: string
  deletable?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  nontag: false,
  deletable: false
})

const emits = defineEmits(['delete'])

const fieldValue = computed(() => {
  if (props.field) return dataStore.field(props.field)
  return null
})
</script>

<style lang="scss" scoped>
.generated-10 {
    width: 1.5rem;
    height: 1.5rem;
}
</style>
